import useYoutubeChannelTabs from '../youtube-course/useYoutubeChannelTabs';
import useGoalInfo from '../goal/useGoalInfo';
import useSinglePlaylists from './useSinglePlaylists';

const useFullSingleYoutubeCourses = (goalUID, fallbackData) => {
  const { key: singleYoutubePlaylistsSWRKey } = useSinglePlaylists(goalUID, {
    fallbackData: fallbackData.singlePlaylists
  });

  const { key: youtubeChannelTabsSWRKey } = useYoutubeChannelTabs(goalUID, {
    fallbackData: fallbackData.channelTabsData
  });

  const { key: goalInfoSWRKey } = useGoalInfo(goalUID, {
    fallbackData: fallbackData.goalData
  });

  return {
    keys: {
      singleYoutubePlaylistsSWRKey,
      youtubeChannelTabsSWRKey,
      goalInfoSWRKey
    }
  };
};

export default useFullSingleYoutubeCourses;
